var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"timeline-scroller-gap",class:{
    visible: !_vm.isScrollDown,
  },attrs:{"id":"mobile-header"}},[_c('div',{staticClass:"logo"},[_c('a',{attrs:{"href":_vm.homeUrl}},[_c('XImg',{attrs:{"src":_vm.banner,"svg-tag":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('UploadMenuItem'),_vm._v(" "),_c('SearchbarMenuItem')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }